import React from 'react';
import {useParams} from 'react-router';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {useBulkUpdate} from 'services/data';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {Scene} from 'components';
import {BulkUpdateDetailsSceneCore} from './BulkUpdateDetailsSceneCore';

export const BulkUpdateDetailsScene: React.FC = () => {
  const codelistIds = useAllCodeListIds();
  const thesaurusIds = useAllThesaurusIds();
  const {bulkUpdateId} = useParams();
  const {status, data} = useBulkUpdate(bulkUpdateId ?? 'missing bulkUpdateId');

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        {status === 'NotLoaded' ||
        status === 'Loading' ||
        status === 'Failed' ? (
          <Scene>
            <Scene.Header title="" />
            <Scene.Content
              loadStatus={status}
              error={
                status === 'Failed' ? 'Failed to load bulk update' : undefined
              }
            />
          </Scene>
        ) : (
          <BulkUpdateDetailsSceneCore bulkUpdate={data!} />
        )}
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
